// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__-GslP","container_video":"styles_container_video__6MWp7","video":"styles_video__-r464","container_content":"styles_container_content__1vjJI"};